import { useRef, useState } from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
export const firstZodIssue = (error) => error.issues[0]?.message ?? error.message;
// Shared edit plumbing for the proposal body components: a patch of edited
// fields, validation of input+patch against the tool's schema, and emission
// of the ProposalEditsState the approve/retry buttons key on. Components own
// only their per-field baseline diffing.
export const useProposalEdits = (tool, input, onEditsChange) => {
    const patch = useRef({});
    const [editError, setEditError] = useState(null);
    const emit = () => {
        const edits = { ...patch.current };
        const parsed = tool.inputSchema.safeParse({ ...input, ...edits });
        setEditError(parsed.success ? null : firstZodIssue(parsed.error));
        onEditsChange?.({
            edits: Object.keys(edits).length > 0 ? edits : null,
            isValid: parsed.success,
        });
    };
    return { patch, editError, emit };
};
export const EditError = styled.div `
  font-size: 0.8em;
  color: ${THEME.DANGEROUS};
  white-space: pre-wrap;
`;
export const IconButton = styled.button `
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: ${THEME.COLOR_GREY};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${THEME.COLOR_PRIMARY};
    background: ${THEME.SURFACE_MUTED};
  }
`;
export const Section = styled.div `
  margin-top: 10px;
  font-size: 0.85em;
`;
export const SectionLabel = styled.div `
  color: ${THEME.COLOR_GREY};
  font-size: 0.75em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
`;
export const SectionValue = styled.div `
  font-size: 0.95em;
  word-break: break-word;
  color: ${THEME.COLOR_PRIMARY};
`;
export const Inline = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;
export const Pill = styled.span `
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  background: ${THEME.BACKGROUND};
  color: ${THEME.COLOR_PRIMARY};
  border: 1px solid ${THEME.BORDER};
  font-size: 0.85em;
  font-weight: 500;
  letter-spacing: 0.02em;
`;
export const Body = styled.div `
  background: #fff;
  border: 1px solid ${THEME.BORDER};
  border-radius: 3px;
  padding: 10px 12px;
  font-size: 0.95em;
  line-height: 1.5;
  max-height: 280px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  color: ${THEME.COLOR_PRIMARY};
`;
export const RawJson = styled.pre `
  background: ${THEME.SURFACE_INSET};
  border: 1px solid ${THEME.BORDER};
  border-radius: 3px;
  padding: 8px 10px;
  font-size: 0.8em;
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  color: ${THEME.COLOR_PRIMARY};
`;
export const Table = styled.table `
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8em;

  th,
  td {
    text-align: left;
    padding: 4px 8px;
    border-bottom: 1px solid ${THEME.BORDER};
  }

  th {
    color: ${THEME.COLOR_GREY};
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
`;
//# sourceMappingURL=shared.js.map